import React from 'react';

export class App extends React.Component {
	render() {
		return (
			<div>My simple Reacta Webpack Babel App</div>
		);
	}
}

React.render(<App/>, document.querySelector("#myApp"));


/** WEBPACK FOOTER **
 ** ./index.jsx
 **/